import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  ActionIcon,
  Box,
  Divider,
  Group,
  Paper,
  Stack,
  Switch,
  Text,
  Tooltip,
} from "@mantine/core";
import {
  ISpaceValidation,
  SPACE_VALIDATIONS,
} from "../../RoomSideBar/SpaceValidations/spaceValidationsUtils";
import React from "react";
import { thunkRunSpaceValidations, toggleSpaceValidationSpecInRedux } from "../designSlice";
import { FaInfo } from "react-icons/fa6";

const ValidationTableSettings: React.FC = () => {
  const activeSpaceValidationSpecs = useAppSelector(
    (state) => state.design.activeSpaceValidationSpecs
  );

  const spaceValidationRun = useAppSelector((state) => state.design.spaceValidationRun);

  const dispatch = useAppDispatch();

  const toggle = (validation: ISpaceValidation) => {
    dispatch(toggleSpaceValidationSpecInRedux(validation.id));
    if (spaceValidationRun.active) {
      dispatch(thunkRunSpaceValidations(false));
    }
  };

  return (
    <Paper withBorder radius="md" p={0} bg="white">
      <Box px="md" py="sm">
        <Text fw={700} size="sm">
          Regler
        </Text>
        <Text size="xs" c="dimmed" mt={2}>
          Välj vilka kontroller som ska ingå i valideringen.
        </Text>
      </Box>

      <Divider />

      <Stack gap={0}>
        {SPACE_VALIDATIONS.map((validation) => {
          return (
            <Group
              key={validation.id}
              justify="space-between"
              gap="sm"
              wrap="nowrap"
              px="md"
              py="sm"
              style={{ borderBottom: "1px solid #f1f3f5" }}
            >
              <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
                <Tooltip label={validation.description} multiline maw={280}>
                  <ActionIcon variant="subtle" color="gray" size="sm" aria-label={validation.title}>
                    <FaInfo size={11} />
                  </ActionIcon>
                </Tooltip>
                <Text size="sm" style={{ lineHeight: 1.25 }}>
                  {validation.title}
                </Text>
              </Group>
              <Switch
                checked={activeSpaceValidationSpecs[validation.id]}
                onChange={() => toggle(validation)}
                size="md"
              />
            </Group>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default ValidationTableSettings;
